// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec52b659","455":"66971cf2","977":"f9e2e8d6"}[chunkId] + ".chunk.js";
};